import { render, staticRenderFns } from "./TrainingLayout.vue?vue&type=template&id=2975a632&scoped=true&"
import script from "./TrainingLayout.vue?vue&type=script&lang=js&"
export * from "./TrainingLayout.vue?vue&type=script&lang=js&"
import style0 from "./TrainingLayout.vue?vue&type=style&index=0&id=2975a632&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2975a632",
  null
  
)

export default component.exports